export const AUTH_TOKEN_KEY = 'aa-vie_broker_auth_token'
export const USER_KEY = 'aa-vie_broker_auth_user'
